<template>
  <div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">작업기간</span></label>
      <div class="col-4 pt-2">
        <DatePicker class="form-control" type="date" range :append-to-body="true"
          :value="permit.workPeriod"
          :clearable="false" :editable="false"
          :disabled-date="scheduleDateDisabledFn"
          @change="(val) => { permit.workPeriod = val; }"
          style="font-size: 12px;" input-class="calendar-input">
          <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
        </DatePicker>
      </div>
    </div>
    <!-- 운전중 작업 설비 -->
    <div class="form-group row">
      <label class="col-2 form-control-label"><span>운전중 작업 설비</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md light-blue" @click="addOperatingWorkRow">
            <i class="icon-plus mr-5"></i>행 추가
          </button>
          <button class="btn btn-md line-2" @click="removeOperatingWorkRows" :disabled="!hasCheckedRows(permit.facilities)">
            <i class="icon-minus mr-5"></i>행 삭제
          </button>
        </div>
        <table class="tbl v-tbl">
          <colgroup>
            <col width="40px">
            <col width="50px">
            <col>
            <col>
            <col>
          </colgroup>
          <thead class="no-drag">
            <tr>
              <th>
                <label class="md-check">
                  <input type="checkbox" v-model="operatingWorkCheckAll">
                  <i class="blue"></i>
                </label>
              </th>
              <th>번호</th>
              <th><span class="ess">설비명</span></th>
              <th>작업범위</th>
              <th><span class="ess">작업내용</span></th>
            </tr>
          </thead>
          <tbody v-if="permit.facilities.length === 0">
            <tr>
              <td colspan="5" style="text-align:center">데이터가 없습니다.</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(row, index) in permit.facilities" :key="row.id">
              <td>
                <label class="md-check">
                  <input type="checkbox" v-model="row.checked">
                  <i class="blue"></i>
                </label>
              </td>
              <td>{{ index + 1 }}</td>
              <td><input type="text" class="form-control" v-model="row.facilityName" placeholder="설비명"
                    :style="(rowInUse(row) && !(row.facilityName || '').trim()) ? { borderColor:'#eb5757' } : {}"></td>
              <td><input type="text" class="form-control" v-model="row.workScope" placeholder="작업범위"></td>
              <td><input type="text" class="form-control" v-model="row.workContent" placeholder="작업내용"
                    :style="(rowInUse(row) && !(row.workContent || '').trim()) ? { borderColor:'#eb5757' } : {}"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DrivingWorkPermit',
  props: {
    permit: {
      type: Object,
      required: true
    },
    scheduleDateDisabledFn: {
      type: Function,
      default: () => false
    }
  },
  computed: {
    operatingWorkCheckAll: {
      get() {
        return this.permit.facilities.length > 0 && this.permit.facilities.every((row) => row.checked);
      },
      set(value) {
        this.permit.facilities.forEach((row) => {
          row.checked = value;
        });
      }
    }
  },
  methods: {
    addOperatingWorkRow() {
      this.permit.facilities.push({ checked: false, id: Date.now(), facilityName: '', workScope: '', workContent: '' });
    },
    removeOperatingWorkRows() {
      const next = this.permit.facilities.filter((row) => !row.checked);
      this.permit.facilities = next.length > 0 ? next : [{ checked: false, id: Date.now(), facilityName: '', workScope: '', workContent: '' }];
    },
    hasCheckedRows(list) {
      return list.some((row) => row.checked);
    },
    rowInUse(row) {
      return !!(String(row.facilityName || '').trim() || String(row.workScope || '').trim() || String(row.workContent || '').trim());
    }
  }
}
</script>